import {
  authorizedGetCall,
  authorizedPostCall,
  authorizedDeleteCall,
} from "./APIsService";

export const getModerators = (search = null) => {
  return new Promise((resolve, reject) => {
    let url = `moderators`;
    if (search) {
      url += `?searchQuery=${encodeURIComponent(search)}`;
    }

    authorizedGetCall(url)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addModerator = (data) => {
  return new Promise((resolve, reject) => {
    authorizedPostCall(`moderators`, data)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteModerator = (id) => {
  return new Promise((resolve, reject) => {
    authorizedDeleteCall(`moderators/${id}`)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const changeModeratorStatus = (id, status) => {
  return new Promise((resolve, reject) => {
    authorizedPostCall(`moderators/${id}/status`, { status })
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const resendLoginLink = (id) => {
  return new Promise((resolve, reject) => {
    authorizedPostCall(`moderators/${id}/resend-login-link`)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
